export enum SearchFormTabValues {
  Flights = "flights",
  Hotels = "hotels",
  Packages = "packages",
}
